<template>
  <div class="layout__container layout__padding-20-0 layout__position__relative">
    <router-link
      to="/directmailr"
      class="link__colour-teal"
    >
      <el-button class="button__background-tickled-pink button__promo artwork-preview preserve-bg">
        <h3 class="mb-0">
          20/20 campaigns <br><br>
          from just £22.80
        </h3>
      </el-button>
    </router-link>

    <div class="layout__padding-clear layout__width-800px">
      <StepGuide :stepCount="0" />
    </div>

    <div class="layout__padding-clear layout__width-80 text__align-center">
      <div class="text__align-center text__colour-white layout__margin__bottom-25px">
        <div class="layout__padding-clear layout__width-50 layout__padding-40px-0">
          <h2 class="text__colour-teal">Artwork Preview</h2>
        </div>
      </div>

      <div class="layout__width-100 layout__position__relative">
        <div class="layout__width-100 layout__padding-clear">
          <carousel
            :per-page="3"
            :autoplayTimeout="3000"
            :autoplay="true"
            :paginationSize="20"
            paginationActiveColor="#00859c"
            :loop="true"
            :speed="1000"
          >
            <slide
              class="layout__padding-clear layout__overflow-hidden"
              v-for="(thumb, index) in this.printJob.imageUrlThumb"
              :key="thumb.thumbnailURL"
            >
              <div class="layout__margin__bottom-25px">
                <img
                  class="layout__border__all-1px-grey layout__width-100"
                  :src=thumb.thumbnailURL
                >
                <p class="layout__padding-20-0">
                  Page {{ index + 1 }}
                </p>
              </div>
            </slide>
          </carousel>
        </div>
      </div>

      <div class="layout__padding-20-0 layout__overflow-hidden">
        <div class="">
          {{ printJob.printJobSpec.pageCount }} pages | {{ printJob.printJobSpec.actualPageWidth }}mm x
          {{ printJob.printJobSpec.actualPageHeight }}mm | {{ printJob.printJobSpec.pageOrientation }}
        </div>

        <div
          v-if="error"
          class="layout__margin__top-10 text__colour-red"
        >
          {{ error }}
        </div>

        <div class="text__align-center layout__padding-20-0">
          <el-button
            class="button-teal button__base layout__width-150px layout__margin__right-20px"
            :disabled="isLoading"
            @click="startAgain"
          >
            Start again
          </el-button>
          <el-button
            v-if="isA3Job"
            :disabled="isLoading"
            class="button-teal button__base layout__width-150px layout__margin__right-20px"
            @click="convertToA2"
          >
            Convert to A2
          </el-button>
          <el-button
            class="button__base button-red layout__width-150px"
            :disabled="isLoading"
            @click="next"
          >
            Confirm
          </el-button>
        </div>

        <p class="align-center text__size-12">
          By clicking 'Confirm' you are agreeing that your artwork is correct and
          you are happy to proceed to the next step.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Router from '../../../router';
import StepGuide from '@/components/tools/pdfupload/StepGuide.vue';
import { axios } from '@/mixins/Axios.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import { backing } from '@/mixins/Backing.js';
import { Carousel, Slide } from 'vue-carousel';
import Axios from 'axios';

export default {
  name: 'start',

  props: {
    printJob: Object,
    searchParams: Object,
  },

  components: {
    StepGuide,
    Carousel,
    Slide,
  },

  mixins: [axios, dataFormatter, backing],

  data() {
    return {
      isLoading: false,
      error: '',
    };
  },

  computed: {
    orientation() {
      return this.printJob?.printJobSpec?.pageOrientation?.toLowerCase();
    },

    isA3Job() {
      if (!this.printJob) {
        return false;
      }

      const sizes = {
        portrait: {
          pageWidth: 297,
          pageHeight: 420,
        },
        landscape: {
          pageHeight: 297,
          pageWidth: 420,
        },
      };

      if (!sizes[this.orientation]) {
        return false;
      }

      return sizes[this.orientation].pageWidth === this.printJob.printJobSpec.pageWidth
        && sizes[this.orientation].pageHeight === this.printJob.printJobSpec.pageHeight;
    },
  },

  created() {
    this.error = '';
    this.isLoading = false;

    if (typeof this.printJob === 'undefined') {
      this.printJob = JSON.parse(window.sessionStorage.getItem('_printJob'));
      console.log(this.printJob);
    }
  },

  methods: {
    next() {
      Router.push({
        name: '/instant-print/products',
        params: {
          printJob: this.printJob,
          searchParams: this.searchParams,
        },
      });
    },

    startAgain() {
      Router.push({
        name: '/instant-print',
        params: {
          printJob: this.printJob,
          searchParams: this.searchParams,
        },
      });
    },

    async convertToA2() {
      if (!this.isA3Job) {
        return;
      }

      this.error = '';
      this.isLoading = true;

      const url = `${process.env.VUE_APP_TKGATEWAY}/api/v1/pdfUpload/Orders/ResizePDF/${this.printJob.id}`;

      const sizes = {
        portrait: {
          pageWidth: 420,
          pageHeight: 594,
        },
        landscape: {
          pageWidth: 594,
          pageHeight: 420,
        },
      };

      const data = {
        PrintJobSpec: {
          PageWidth: sizes[this.orientation].pageWidth,
          PageHeight: sizes[this.orientation].pageHeight,
        },
      };

      try {
        await Axios.post(url, data, this.returnHeaderUsingToken());
      } catch (error) {
        this.error = error.response.data;
        this.isLoading = false;

        return;
      }

      this.isLoading = false;

      await this.resetJobSpec();
    },

    async resetJobSpec() {
      this.isLoading = true;

      const url = `${process.env.VUE_APP_TKGATEWAY}/api/v1/pdfUpload/orders/${this.printJob.id}?resetJobSpec=true`;

      const data = {
        PrintJobSpec: {},
      };

      let response;

      try {
        response = await Axios.put(url, data, this.returnHeaderUsingToken());

        if (response.data) {
          Router.replace({
            name: '/instant-print/artwork-preview',
            params: {
              printJob: response.data,
            },
            query: {
              t: new Date().getTime(),
            },
          });
        }
      } catch (error) {
        this.error = error?.response?.data || 'Something went wrong';
      }

      this.isLoading = false;
    },
  },
};
</script>
